import React from 'react';
import { Box, Typography } from '@mui/material';
import { AccessTime as TimeIcon } from '@mui/icons-material';

export default function Timer({ seconds }) {
  const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
  const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
  const s = String(seconds % 60).padStart(2, '0');
  
  const isUrgent = seconds < 600; // 10분 미만일 때 긴급 상태
  const isCritical = seconds < 300; // 5분 미만일 때 위험 상태

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1,
        px: 2,
        py: 1,
        borderRadius: 2,
        background: isCritical ? 
          'linear-gradient(45deg, #f44336 30%, #ff5722 90%)' :
          isUrgent ? 
          'linear-gradient(45deg, #ff9800 30%, #ffc107 90%)' :
          'linear-gradient(45deg, #4caf50 30%, #8bc34a 90%)',
        color: 'white',
        boxShadow: isCritical ? 
          '0 4px 20px rgba(244, 67, 54, 0.4)' :
          isUrgent ? 
          '0 4px 20px rgba(255, 152, 0, 0.4)' :
          '0 4px 20px rgba(76, 175, 80, 0.3)',
        animation: isCritical ? 'pulse 1s infinite' : 'none',
        '@keyframes pulse': {
          '0%': {
            transform: 'scale(1)',
            boxShadow: '0 4px 20px rgba(244, 67, 54, 0.4)'
          },
          '50%': {
            transform: 'scale(1.05)',
            boxShadow: '0 6px 25px rgba(244, 67, 54, 0.6)'
          },
          '100%': {
            transform: 'scale(1)',
            boxShadow: '0 4px 20px rgba(244, 67, 54, 0.4)'
          }
        }
      }}
    >
      <TimeIcon sx={{ fontSize: 20 }} />
      <Typography 
        variant="h6" 
        sx={{ 
          fontFamily: 'monospace',
          fontWeight: 'bold',
          letterSpacing: '1px'
        }}
      >
        {h}:{m}:{s}
      </Typography>
    </Box>
  );
}
